import { DropdownItem } from '@/main/store/@types/dropdown.d';
import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { updateTableDataAction } from '@/main/store/actionsFunctions';
import { END_LOADING, ERROR, START_LOADING, STORE_TABLE, UPDATE_BASIC_TABLE_SCHEMA } from '@/main/store/listEditTypes';
import { SchemaMutationInput } from '@/main/store/@types/store.d';
import { cellNames, columnsToCamelCase, Table } from '@/main/utils/table';
import _ from 'lodash';
import { Status } from '@/main/store/@types/page';

import { listActions } from './types';
import { CRUMB_LABEL_KEY as crumbLabel, NAME as name } from '../constants';
import { apiProvider } from '../api';

const filter = {
	PpId: null as number | null,
};

export const store = listStoreBuilder({
	apiProvider,
	crumbLabel,
	dropdownList: {
		OsobniCis: [] as DropdownItem[],
	},
	tableSetting: {
		isEditable: true,
		columnSettings: {
			ZAZNAM_ID: { isEditable: false },
			CAS_JDN_POC: { isEditable: true, required: true },
			OSOBNI_CIS: { isEditable: true, required: true },
			PRIJMENI: { isEditable: false },
			JMENO: { isEditable: false },
			PRACOVNIK_ID: { isEditable: false },
			PP_ID: { isEditable: false },
			AKTUAL_LEVEL: { isEditable: false },
		},
	},
	extraActions: {
		async [listActions.UPDATE_DELBA_PP_ROWS]({ commit, state, dispatch }, rows) {
			commit(START_LOADING);
			try {
				const isSaved = await apiProvider.updateRows(state.filter.PpId!, rows);
				if (isSaved) {
					await updateTableDataAction(state, commit, dispatch, apiProvider.tableData(state.filter));
				}
				return isSaved;
			} catch (err) {
				dispatch(ERROR, { err }, { root: true });
			} finally {
				commit(END_LOADING);
			}
			return false;
		},
	},
	extraGetters: {},
	extraMutations: {
		[UPDATE_BASIC_TABLE_SCHEMA](state, { data, tableName = STORE_TABLE }: SchemaMutationInput) {
			const table = _.get(state, tableName) as Table;
			table.columns = columnsToCamelCase(data.Columns);
			table.addUpdateStatusColumn();
			table.cellNames = cellNames(table);
			table.operations = data.Operations;
			state.operations = data.Operations;
			table.hasIdColumn = data.HasIdColumn;
			table.status = Status.ok;
		},
	},
	filter,
	localState: {},
	name,
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
		SumaCj: null as number | null,
	},
	rowDetail: null,
});
